import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=5c675214&scoped=true&"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=5c675214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c675214",
  null
  
)

export default component.exports